import React from 'react'

import { TagComponent as Tag } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

import ProgramFeaturesList from 'Pods/Shared/JoinProgramModal/ProgramFeaturesList'

function InfoCard({ isParticipating, translate }) {
  const tagLabel = isParticipating
    ? translate('my_subscriptions.status_card.badge_participating')
    : translate('my_subscriptions.status_card.badge_not_participating')

  const tagColor = isParticipating ? 'primary' : 'grey'

  return (
    <div className="status-card__content">
      <div className="status-card__header">
        <h4 className="status-card__title cgt-legacy-heading-h4">
          {translate('my_subscriptions.status_card.title')}
        </h4>
        <Tag color={tagColor} type="ghost" small>
          {tagLabel}
        </Tag>
      </div>

      <p className="status-card__description cgt-legacy-text-default">
        {translate('my_subscriptions.status_card.description')}
      </p>

      <ProgramFeaturesList translate={translate} className="status-card__features" />
    </div>
  )
}

InfoCard.propTypes = {
  isParticipating: bool.isRequired,
  translate: func.isRequired,
}

export default InfoCard
